import { Link } from 'react-router-dom';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { toast } from '@osago/ui';
import { Button, TextInput } from '@osago/ui';

import { isAccountsConfigured, requestPasswordReset } from '../helpers/accountsAuth';
import { passResetService } from '../services/passResetService';
import { ymEvent } from '../hooks/useYandexMetrika';
import { YandexMetrikaEvent } from '../types/metrica/YandexMetrikaEvent';

interface PassResetFormData {
  email: string;
}

const schema = {
  email: {
    required: 'Укажите ваш email или телефон',
    pattern: {
      // value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      value: /^(?:[0-9+\-\s()]{6,}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
      message: 'Неправильный формат',
    },
  },
};

const PassResetForm = () => {
  const { control, handleSubmit, formState: { errors }, reset } = useForm<PassResetFormData>();

  const onResetFormSubmit: SubmitHandler<PassResetFormData> = async (data) => {
    ymEvent(YandexMetrikaEvent.LK_RESETPASS_FORM_SUBMIT);

    if (isAccountsConfigured()) {
      // Новый сервис присылает ссылку на смену пароля, а не готовый пароль, и
      // намеренно отвечает одинаково для существующего и несуществующего адреса -
      // наличие аккаунта наружу не подтверждаем. Поэтому и сообщение обтекаемое.
      await requestPasswordReset(data.email);
      ymEvent(YandexMetrikaEvent.LK_RESETPASS_FORM_SUCCESS);
      toast.success(
        `Если ${data.email} зарегистрирован, мы отправили на него ссылку для смены пароля`
      );
      reset({});
      return;
    }

    const [requestError, res] = await passResetService(data);
    const failed = Boolean(requestError || !res || res.error);

    if (failed) {
      ymEvent(YandexMetrikaEvent.LK_RESETPASS_FORM_ERROR)
    } else {
      ymEvent(YandexMetrikaEvent.LK_RESETPASS_FORM_SUCCESS)
    }

    !failed
      ? toast.success(
        `Новый пароль отправлен на: ${data.email}. Вернитесь НАЗАД`
      )
      : toast.error(res?.message || 'Не удалось отправить пароль, попробуйте позже');

    reset({});
  };

  return (
    <form
      className="form w-full max-w-lg"
      onSubmit={handleSubmit(onResetFormSubmit)}
      noValidate
    >
      <header className="text-center mb-8">
        <h1 className="logo text-3xl">Личный кабинет</h1>
        <p className="font-medium">Восстановление пароля</p>
      </header>
      <div className="mb-8">
        <Controller
          name="email"
          control={control}
          rules={schema.email}
          defaultValue=""
          render={({ field }) => (
            <TextInput
              id="email"
              label="Электронная почта или мобильный телефон"
              type="email"
              placeholder="Ваш емейл или телефон"
              hasError={!!errors.email}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
          )}
        />
        <p className="helper helper--danger mt-1">
          {errors.email?.message}
        </p>
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-between">
        <Button
          type="submit"
          className="w-full sm:w-auto mb-2 sm:mb-0"
        >
          Сбросить
        </Button>
        <Link
          onClick={() => ymEvent(YandexMetrikaEvent.LK_RESETPASS_BACK_CLICK)}
          to="/"
          className="text-sm text-royalblue font-semibold hover:underline"
        >
          НАЗАД
        </Link>
      </div>
    </form>
  );
};

export default PassResetForm;
